<ng-container *transloco="let t; lang: 'es'">
  <div class="modal-header">
    <h4 class="modal-title">{{ t('acknowledgment.title') }}</h4>
  </div>
  <div class="modal-body p-8">
    <div class="form-check mb-5">
      <input class="form-check-input" type="checkbox" id="spanishAcknowledgmentStatement" name="spanishAcknowledgmentStatement"
        [(ngModel)]="acknowledged" required />
      <label class="form-check-label fs-6" for="spanishAcknowledgmentStatement" [innerHTML]="html(content?.statementHtml)"></label>
    </div>
    <div class="fs-6 text-gray-700" [innerHTML]="html(content?.noteHtml)"></div>
  </div>
  <div class="modal-footer flex-column align-items-stretch">
    <button type="button" class="btn btn-primary w-100" [disabled]="!canContinue" (click)="activeModal.close(true)">
      {{ t('acknowledgment.continue') }}
    </button>
    <button type="button" class="btn btn-link" (click)="activeModal.close(false)">
      {{ t('acknowledgment.continueInEnglish') }}
    </button>
  </div>
</ng-container>
